import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from '@app/services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  constructor(public alertService: AlertService) {}

  ngOnInit() {}
}
